var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF504A"
    },
    d: "M438.162,273.162H386.19c-40.719,0-74.067,33.204-74.067,73.923v81.51 c0,24.431,20.097,44.444,44.529,44.444H467.7c24.432,0,44.3-20.013,44.3-44.444v-81.51C512,306.365,478.881,273.162,438.162,273.162 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7959"
    },
    d: "M412.176,273.161H386.19c-40.719,0-74.067,33.204-74.067,73.923v81.51 c0,24.431,20.097,44.444,44.529,44.444h55.524L412.176,273.161L412.176,273.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF504A"
    },
    d: "M412.176,121.737c-36.623,0-66.417,29.795-66.417,66.417c0,36.623,29.794,66.418,66.417,66.418 s66.417-29.795,66.417-66.418C478.593,151.533,448.799,121.737,412.176,121.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7959"
    },
    d: "M412.176,121.737c-36.623,0-66.417,29.795-66.417,66.417c0,36.623,29.794,66.418,66.417,66.418 V121.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FD163"
    },
    d: "M126.038,273.162H74.067C33.348,273.162,0,306.365,0,347.084v81.51 c0,24.431,20.097,44.444,44.529,44.444h111.048c24.432,0,44.3-20.013,44.3-44.444v-81.51 C199.877,306.365,166.758,273.162,126.038,273.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EFF76"
    },
    d: "M100.053,273.161H74.067C33.348,273.161,0,306.365,0,347.084v81.51 c0,24.431,20.097,44.444,44.529,44.444h55.524C100.053,473.039,100.053,273.161,100.053,273.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3594C7"
    },
    d: "M301.222,234.766h-90.444c-40.719,0-73.846,33.127-73.846,73.846v149.521 c0,8.157,6.613,14.769,14.769,14.769h208.598c8.157,0,14.769-6.612,14.769-14.769V308.612 C375.068,267.893,341.941,234.766,301.222,234.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16DCFA"
    },
    d: "M256.499,234.766h-45.721c-40.719,0-73.846,33.127-73.846,73.846v149.521 c0,8.157,6.613,14.769,14.769,14.769h104.798L256.499,234.766L256.499,234.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3594C7"
    },
    d: "M256,38.96c-48.97,0-88.81,39.84-88.81,88.81s39.839,88.81,88.81,88.81s88.81-39.84,88.81-88.81 S304.97,38.96,256,38.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16DCFA"
    },
    d: "M256,38.96c-48.97,0-88.81,39.84-88.81,88.81s39.839,88.81,88.81,88.81V38.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FD163"
    },
    d: "M100.053,121.737c-36.623,0-66.417,29.795-66.417,66.417c0,36.623,29.794,66.418,66.417,66.418 s66.417-29.795,66.417-66.418C166.47,151.533,136.676,121.737,100.053,121.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EFF76"
    },
    d: "M100.053,121.737c-36.623,0-66.417,29.795-66.417,66.417c0,36.623,29.794,66.418,66.417,66.418 V121.737z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/Agent.43b749ae41d0c2f1aeefc47b469370d0.svg";
export { ForwardRef as ReactComponent };